import { useBootstrap } from '../context/BootstrapContext'

export function useSchedule() {
  const { data, loading } = useBootstrap()
  return { schedule: data.schedule, loading }
}
